(() => {
  const previewRetryDelays = [500, 1200, 2400, 4000];

  function retryPreview(image, previewUrl, attempt = 0) {
    if (attempt >= previewRetryDelays.length) return;
    window.setTimeout(() => {
      if (!image.isConnected) return;
      const probe = new Image();
      probe.onload = () => {
        if (!image.isConnected) return;
        image.src = probe.src;
      };
      probe.onerror = () => retryPreview(image, previewUrl, attempt + 1);
      probe.src = `${previewUrl}${previewUrl.includes('?') ? '&' : '?'}retry=${Date.now()}-${attempt}`;
    }, previewRetryDelays[attempt]);
  }

  function onPreviewError(event) {
    const image = event.target;
    if (!(image instanceof HTMLImageElement) || !image.matches('[data-cozy-preview]') || image.dataset.cozyPreviewFallbackApplied === 'true') return;
    const fallback = image.dataset.cozyPreviewFallback;
    if (!fallback) return;
    const previewUrl = image.src;
    image.dataset.cozyPreviewFallbackApplied = 'true';
    image.removeAttribute('data-cozy-preview');
    image.src = fallback;
    retryPreview(image, previewUrl);
  }

  document.addEventListener('error', onPreviewError, true);
  document.querySelectorAll('[data-cozy-preview]').forEach(image => {
    if (image.complete && image.naturalWidth === 0) onPreviewError({ target: image });
  });

  function previewModalFrom(node) {
    return node?.closest?.('cart-drawer')?.querySelector?.('[data-cozy-cart-preview-modal]') || null;
  }

  function closeCartPreview(modal) {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    const image = modal.querySelector('[data-cozy-cart-preview-image]');
    if (image) image.removeAttribute('src');
    const trigger = modal._cozyPreviewTrigger;
    modal._cozyPreviewTrigger = null;
    const drawer = modal.closest('cart-drawer');
    if (drawer?.classList.contains('active')) trapFocus(drawer.querySelector('.drawer__inner'), trigger);
    else removeTrapFocus(trigger?.isConnected ? trigger : undefined);
  }

  function openCartPreview(trigger) {
    const modal = previewModalFrom(trigger);
    const source = trigger.querySelector('img');
    const image = modal?.querySelector('[data-cozy-cart-preview-image]');
    if (!modal || !source || !image) return;
    image.src = source.currentSrc || source.src;
    image.alt = source.alt || '';
    modal._cozyPreviewTrigger = trigger;
    modal.hidden = false;
    trapFocus(modal, modal.querySelector('[data-cozy-cart-preview-close]'));
  }

  function onPreviewClick(event) {
    const trigger = event.target.closest?.('[data-cozy-cart-preview-trigger]');
    if (trigger) {
      event.preventDefault();
      openCartPreview(trigger);
      return;
    }
    const close = event.target.closest?.('[data-cozy-cart-preview-close]');
    const modal = event.target.closest?.('[data-cozy-cart-preview-modal]');
    if (close || (modal && event.target === modal)) closeCartPreview(modal || previewModalFrom(close));
  }

  function onPreviewKeydown(event) {
    if (event.key !== 'Escape') return;
    const modal = document.querySelector('[data-cozy-cart-preview-modal]:not([hidden])');
    if (!modal) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    closeCartPreview(modal);
  }

  document.addEventListener('click', onPreviewClick);
  document.addEventListener('keydown', onPreviewKeydown, true);


  const fetchCart = () => fetch(`${routes.cart_url}.js`, { credentials: 'same-origin' }).then(response => response.json());
  // Keep the editor integration; bundle prices now come from Shopify discounts.
  window.CozyStoryBundleCart = {
    reconcile: () => window.CozyStoryGiftWrap ? window.CozyStoryGiftWrap.reconcile() : fetchCart(),
    personalizedQuantity: cart => (cart?.items || []).reduce((total, item) => total + (item.properties?._cozystory_build_id ? Number(item.quantity) || 0 : 0), 0),
    desiredGiftQuantity: () => 0,
    openDrawer() {
      const drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.open(document.querySelector('#cart-icon-bubble'));
      else window.location.assign(routes.cart_url);
    }
  };
})();
